const routes = [
    {
        path: "/course/assessments",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "courseassessment_index"
        }
    }
]

export default routes;
